import { Link } from "react-router-dom";
import useReveal from "@/hooks/useReveal";

const services = [
  {
    icon: "ri-brush-4-line",
    title: "에폭시 바닥공사",
    slug: "epoxy",
    externalUrl: "https://blog.naver.com/ksh1009000",
    desc: "공장, 물류창고, 주차장의 내마모·내화학성 에폭시 라이닝 시공",
    img: "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/aa5a0441-6833-4bb8-b640-d9671a64458a_compressed_39.webp",
  },
  {
    icon: "ri-drop-line",
    title: "우레탄 방수",
    slug: "waterproofing",
    externalUrl: "https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=9&parentCategoryNo=9",
    desc: "옥상, 지하주차장, 화학공장 대응 습식·복합 우레탄 방수",
    img: "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/b5d76637-16e8-4694-a346-d8f03e17e1a5_compressed_54.webp",
  },
  {
    icon: "ri-building-2-line",
    title: "외벽도장",
    slug: "exterior-painting",
    externalUrl: "https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=13&parentCategoryNo=13",
    desc: "고층 아파트·공장·상업시설 로프·달비계 외벽 도장",
    img: "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/694cf293-e32f-4434-a2d7-c7bb302a0fad_compressed_12.webp",
  },
  {
    icon: "ri-paint-brush-line",
    title: "내부도장",
    slug: "interior-painting",
    externalUrl: "https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=14",
    desc: "학교, 사무실, 병원의 저 VOC 친환경 내부 도장 시공",
    img: "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/eb5caa02-8536-4fb7-b7a6-66409af58923_compressed_19.webp",
  },
  {
    icon: "ri-home-4-line",
    title: "실내건축",
    slug: "interior-architecture",
    externalUrl: "https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=27&parentCategoryNo=27",
    desc: "관공서, 학교, 사무실 인테리어 리모델링 종합 시공",
    img: "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/9101bef0-be2d-4c5a-b628-c7e88782b3cc_compressed_57.webp",
  },
  {
    icon: "ri-hammer-line",
    title: "석공사",
    slug: "stonework",
    externalUrl: "https://blog.naver.com/PostList.naver?blogId=ksh1009000&from=postList&categoryNo=29",
    desc: "화강암, 대리석 외장·내장 석재 마감 및 유지보수",
    img: "https://storage.readdy-site.link/project_files/ac2cc551-d4dd-4bc1-9142-393457b4e539/71bb0d67-13a0-4d94-8cb3-a2736aa75d7f_compressed_62.webp",
  },
];

export default function Services() {
  const ref = useReveal<HTMLDivElement>();
  return (
    <section id="services" className="relative w-full py-24 md:py-32 bg-neutral-50">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div ref={ref} className="reveal max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-px bg-point-500"></span>
            <span className="text-point-600 text-xs font-semibold uppercase tracking-[0.3em]">
              Our Business
            </span>
          </div>
          <h2 className="font-hero text-navy-900 text-3xl md:text-5xl lg:text-6xl leading-tight mb-6">
            6개 분야, 하나의 기준
          </h2>
          <p className="text-neutral-600 text-base md:text-lg leading-relaxed">
            제이아이앤씨는 단순 시공을 넘어, 각 공종별 전담 팀과 자체 장비로
            현장 조건에 맞춘 최적의 공법을 제안합니다.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const CardBody = (
              <>
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-950/70 via-navy-900/10 to-transparent"></div>
                  <div className="absolute top-5 left-5 w-12 h-12 flex items-center justify-center rounded-lg bg-white/95 backdrop-blur">
                    <i className={`${s.icon} text-2xl text-navy-900`}></i>
                  </div>
                </div>
                <div className="p-7">
                  <div className="flex items-start justify-between gap-4 mb-3">
                    <h3 className="font-hero text-navy-900 text-2xl">{s.title}</h3>
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-100 group-hover:bg-point-500 group-hover:text-white transition-colors">
                      <i className="ri-arrow-right-up-line text-lg"></i>
                    </div>
                  </div>
                  <p className="text-sm text-neutral-600 leading-relaxed">{s.desc}</p>
                </div>
              </>
            );
            return s.externalUrl ? (
              <a
                key={s.slug}
                href={s.externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative overflow-hidden rounded-2xl bg-white border border-neutral-200 hover:border-point-400 transition-all duration-500 ease-out hover:-translate-y-2 cursor-pointer"
              >
                {CardBody}
              </a>
            ) : (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="group relative overflow-hidden rounded-2xl bg-white border border-neutral-200 hover:border-point-400 transition-all duration-500 ease-out hover:-translate-y-2 cursor-pointer"
              >
                {CardBody}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}